export const getValueCombobox = (value1?: string, value2?: string) =>
  value1 && value2 ? `${value1}_-1_${value2}` : ""
